import { render, staticRenderFns } from "./WidgetSnippet.vue?vue&type=template&id=1ab87fc4&scoped=true&"
import script from "./WidgetSnippet.vue?vue&type=script&lang=js&"
export * from "./WidgetSnippet.vue?vue&type=script&lang=js&"
import style0 from "./WidgetSnippet.vue?vue&type=style&index=0&id=1ab87fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab87fc4",
  null
  
)

export default component.exports